<template>
  <p class="errormessage" :class="noText ? 'notext' : ''">
    {{ errortext ? errortext : '텍스트가없습니다' }}
  </p>
</template>
<script>
export default {
  name: 'ErrorMessage',
  props: {
    errortext: {
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    noText() {
      if (!this.errortext) {
        return true;
      }
      return false;
    }
  }
};
</script>
<style scoped src="@/assets/css/errormessage/errormessage.css"></style>
